import React from 'react'
import Text from '../../Text'
import { $holidaySale, $textPrimary } from '../../../styles/colors/semantics'
import styles from './styles.module.css'

function BlackFridayTag({ show }) {
  return (
    <div
      className={[styles.tag, show ? styles.shown : styles.hidden].join(' ')}
      style={{ background: $holidaySale, color: $textPrimary.dark }}
    >
      <Text type="heading-8">Holiday sale</Text>
    </div>
  )
}

export default BlackFridayTag
